export const calculateDiscountedPrice = (
    pricePerM2: string,
    discountProperty: number,
    totalPrice: string
): string => {
    const pricePerM2Number = typeof pricePerM2 === 'number' ? pricePerM2 : parseInt((pricePerM2 || '').toString().replace(/\s+/g, ''), 10);

    const totalPriceNumber = typeof totalPrice === 'number' ? totalPrice : parseInt((totalPrice || '').toString().replace(/\s+/g, ''), 10);

    if (isNaN(pricePerM2Number) || isNaN(totalPriceNumber) || discountProperty <= 0) {
        const fallbackPrice = typeof totalPrice === 'string' ? totalPrice : String(totalPrice || '0');
        return fallbackPrice;
    }

    const area = totalPriceNumber / pricePerM2Number;

    const discountTotal = discountProperty * area;

    const discountedTotalPrice = Math.floor(totalPriceNumber - discountTotal);

    const result = discountedTotalPrice.toLocaleString('ru-RU');

    return result;
};

export const calculateDiscountedPricePerM2 = (
    pricePerM2: string | number,
    discountProperty: number
): string => {
    const pricePerM2Number = typeof pricePerM2 === 'number' ? pricePerM2 : parseInt((pricePerM2 || '').toString().replace(/\s+/g, ''), 10);
    if (isNaN(pricePerM2Number) || discountProperty <= 0) {
        return pricePerM2.toString();
    }
    const discountedPricePerM2 = Math.floor(pricePerM2Number - discountProperty);
    return discountedPricePerM2.toLocaleString('ru-RU');
};

export const formatPrice = (price: string | number): string => {
    if (typeof price === 'number' && !isNaN(price) && price > 0) {
        return price.toLocaleString('ru-RU');
    }
    if (typeof price === 'string' && price !== '') {
        const numericPrice = Number(price.replace(/\s+/g, ''));
        return !isNaN(numericPrice) && numericPrice > 0 
            ? numericPrice.toLocaleString('ru-RU') 
            : '—';
    }
    return '—';
};

export const getDisplayPricePerM2 = (
    pricePerM2: string | number,
    discountProperty?: number
): string => {
    const hasDiscount = discountProperty && discountProperty > 0;
    return hasDiscount 
        ? calculateDiscountedPricePerM2(pricePerM2, discountProperty)
        : formatPrice(pricePerM2);
};